import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import Button from 'flarum/common/components/Button';

export function addHighlightButton() {
    extend(CommentPost.prototype, 'actionItems', function (items) {
        const post = this.attrs.post;
        if (!post || post.isHidden()) return;
        if (!app.session.user) return;

        const highlightCount = post.attribute('highlightCount') || 0;
        const hasHighlighted = post.attribute('hasHighlighted');

        // Highlight count display
        if (highlightCount > 0) {
            items.add('highlight-count', (
                <span className="Post-merit-counts">
                    <span className="highlight-count"><i className="fas fa-fire" /> {highlightCount}</span>
                </span>
            ), 2);
        }

        // Current user must be at least Jr. Member
        const userRank = app.session.user.attribute('meritRank') || 'Brand New';
        const rankOrdinals: Record<string, number> = {
            'Brand New': 0, 'Newbie': 1, 'Jr. Member': 2, 'Member': 3,
            'Full Member': 4, 'Sr. Member': 5, 'Hero Member': 6, 'Legendary': 7
        };

        if ((rankOrdinals[userRank] || 0) < 2) return;

        items.add('highlight', (
            <Button
                className={'Button Button--link Button--highlight' + (hasHighlighted ? ' active' : '')}
                onclick={() => toggleHighlight(post)}
                icon="fas fa-fire"
            >
                {app.translator.trans('predictiontalk-merit-system.forum.merit.highlight_button')}
            </Button>
        ), 1);
    });
}

async function toggleHighlight(post: any) {
    try {
        await app.request({
            method: 'POST',
            url: app.forum.attribute('apiUrl') + '/merit/highlight/' + post.id(),
        });

        // Reload the post to update attributes
        window.location.reload();
    } catch (e) {
        console.error('Failed to toggle highlight:', e);
    }
}
